<template>
    <fieldset class="form-group">

        <div class="form-group__top" v-if="title">
            <legend class="form-group__label" :class="{tooltip : hint}">
                {{ title }}
                <template v-if="hint">
                    <span class="tooltip__btn" :class="{'opened':toolTipOpened}" @click="toolTipClick">?</span>
                    <div class="tooltip__content">
                        <p>{{ hint }}</p>
                    </div>
                </template>
            </legend>

            <a class="icon-link icon-link--base" :href="link.href" target="_blank" v-if="link">
                <span>{{ link.text }}</span>
                <svg class="icon-link__icon" aria-hidden="true">
                    <use xlink:href="/local/templates/xpage/img/icons/icons.svg#svg-link"></use>
                </svg>
            </a>
        </div>

        <slot name="formSwitch"></slot>

        <div class="form__items" :class="groupClass" v-if="$slots.baseItems">
            <slot name="baseItems"></slot>
        </div>

        <div class="form-group__list" :class="groupClass" v-if="$slots.groupList">
            <slot name="groupList"></slot>
        </div>

        <div class="form-group__radios" :class="groupClass" v-if="$slots.radioList">
            <slot name="radioList"></slot>
        </div>

    </fieldset>
</template>

<script>

export default {
    name: "IPFormGroup",
    data() {
        return {
            toolTipOpened: false
        };
    },
	props: {
        title: {
            type: String,
            default: ''
        },
        groupClass: {
            type: String,
            default: ''
        },
        hint: {
            type: String,
            default: ''
        },
        link: {
            type: Object,
            default: null
        }
	},
    methods: {
        toolTipClick() {
            this.toolTipOpened = this.toolTipOpened === false;
        },
    }
}
</script>

<style scoped>

</style>